import React from 'react'
// libs
import styled from 'styled-components'
import Marquee from 'react-fast-marquee'
import { useSelector } from 'react-redux'
// themes
import colors from 'themes/colors'
// hooks
import { useNetworkStatus } from 'hooks/useNetworkStatus'
// store
import { isSyncingSelector } from 'store/reducers/offlineRisk'

const Text = styled(Marquee)`
  background: ${colors.purple300};
  width: 100vw;
  font-size: 13px;
  position: relative;
  text-align: center;
  height: 24px;
  color: white;
  padding: 2px 0;

  .rfm-child {
    margin-right: 64px;
  }
`

const NetworkStatus: React.FC = () => {
  const onLine = useNetworkStatus()
  const isSyncing = useSelector(isSyncingSelector)

  if (onLine && !isSyncing) {
    return null
  }

  return (
    <Text>
      {isSyncing
        ? 'Syncing...'
        : 'Offline. Changes will sync when the network connection is restored. Some information will need to be finalise once the network connection is restored before submission  '}
    </Text>
  )
}

export default NetworkStatus
